import { searchTerms } from 'owa-timestream-search-store';
import { highlightTermsInHtmlElement } from 'owa-highlight';

export default function highlightTerms(element: HTMLElement) {
    highlightTermsInHtmlElement(element, searchTerms());
}
